"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["user", "name", "profilePictureUrl"],

  data: function data() {
    return {
      show: false
    };
  },


  computed: {
    eventName: function eventName() {
      return "toggle-" + this.name + "-menu";
    },
    fullname: function fullname() {
      return this.user.firstname + " " + this.user.lastname;
    }
  },

  mounted: function mounted() {
    Event.listen(this.eventName, this.toggleMenu);
  },


  methods: {
    toggleMenu: function toggleMenu() {
      this.show = !this.show;
    },
    close: function close() {
      Event.fire(this.eventName);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/menu/MainMenu.vue
// module id = C7Ql
// module chunks = 0 1